"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TendersPanel = void 0;
var React = require("react");
var redux = require("react-redux");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var DocumentPanel_1 = require("./DocumentPanel");
var dispatchers_1 = require("../utils/dispatchers");
var TendersPanel = function (props) {
    var _a = redux.useSelector(function (state) { return ({
        currentBid: state.bid.current.bid,
        tender: state.bid.tender
    }); }), currentBid = _a.currentBid, tender = _a.tender;
    if (currentBid === null || currentBid === void 0 ? void 0 : currentBid.procerement.doNotReceiveTenders)
        return null;
    var isOngoingBidLocked = (currentBid === null || currentBid === void 0 ? void 0 : currentBid.procerement.lockTenders) &&
        (currentBid === null || currentBid === void 0 ? void 0 : currentBid.endAt) > new Date().valueOf();
    var _b = (0, dispatchers_1.mapDispatchers)(redux.useDispatch()), approveSection = _b.approveSection, declineSection = _b.declineSection;
    var handleSectionApproval = function () {
        return tender.participant &&
            approveSection(currentBid, tender.participant, 'tender');
    };
    var handleSectionDecline = function () {
        return tender.participant &&
            declineSection(currentBid, tender.participant, 'tender');
    };
    return (React.createElement(DocumentPanel_1.default, { panelIcon: React.createElement(sok_ui_1.Icon, { className: "fa-file-invoice-dollar" }), panelTitle: (0, translation_1.getLocalization)('bid/tenderscard/tender'), section: "tender", disableButtons: props.disableButtons, approveSection: handleSectionApproval, declineSection: handleSectionDecline, baseUrl: props.baseUrl, metaschema: tender.metaSchema.list, isContentLocked: isOngoingBidLocked }));
};
exports.TendersPanel = TendersPanel;
